module.exports = __webpack_public_path__ + "img/refill-water-bottle.0d266701.svg";